// extracted by mini-css-extract-plugin
export var button = "_68-4";
export var hasDarkBackground = "_68-7";
export var hasLightBackground = "_68-6";
export var iconWrapper = "_68-0";
export var large = "_68-2";
export var medium = "_68-1";
export var small = "_68-5";
export var xsmall = "_68-3";